var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -6.6,
    y: -6.6,
    width: 50.1011,
    height: 50.1011
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.3px)",
      clipPath: "url(#bgblur_0_2001_26_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 6.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 36.4011,
    height: 36.4011,
    fill: "url(#paint0_radial_2001_26)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 36.4011,
    height: 36.4011,
    stroke: "#F0E1CE",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5563 7.77817C16.2753 8.4972 18.0617 8.85823 19.6843 9.03801C21.7747 9.27331 23.8977 9.17951 25.9427 8.68301C27.476 8.31064 29.1883 7.71278 30.1178 6.78329M30.1178 6.78329C29.1883 7.71278 28.5894 9.42601 28.218 10.9583C27.7225 13.0043 27.6287 15.1273 27.8621 17.2158C28.0428 18.8394 28.4058 20.6277 29.1229 21.3448M30.1178 6.78329L6.78324 30.1178",
    stroke: "#F0E1CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2001_26_clip_path",
    transform: "translate(6.6 6.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 36.4011,
    height: 36.4011
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2001_26",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4506 18.4506) rotate(90) scale(18.4506)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B0B0B",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.29
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluar);
export default __webpack_public_path__ + "static/media/bluar.f46f6cf18a5b5734ee974fcf739e42fe.svg";
export { ForwardRef as ReactComponent };